import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { UtilsService } from '@app/core/services';
import { IValueInputCryptoAddressModel } from '@app/views/pages/deposit/crypto-address/models/value-input-crypto-address.model';
import { map, Observable } from 'rxjs';
import { ICryptoListModel, ICryptoNetworkModel } from '../models';
import { ICryptoAddress } from '@app/views/pages/deposit/crypto-address/models/crypto-address';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  constructor(
    @Inject(APP_CONFIG) private appConfig: IAppConfig,
    private httpClient: HttpClient,
    private utilsService: UtilsService
  ) { }


  getCurrencies(): Observable<any> {
    return this.httpClient.get<ICryptoListModel[]>(`${this.appConfig.apiEndpoint}/crypto-transaction/crypto-network/currencies`)
      .pipe(map(this.utilsService.handleResponse));
  }

  getCurrencyNetwork(currencyId: number): Observable<any> {
    return this.httpClient.get<ICryptoNetworkModel[]>(`${this.appConfig.apiEndpoint}/crypto-transaction/crypto-network/${currencyId}`)
      .pipe(map(this.utilsService.handleResponse));
  }

  getCurrencyNetworkFees(currencyId: number): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfig.apiEndpoint}/crypto-transaction/crypto-network/withdrawable/${currencyId}`)
      .pipe(map(this.utilsService.handleResponse));
  }
}
